import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { datadogLogs } from "@datadog/browser-logs";
import courseApprovalService from "@/services/courseApproval.js";
import { queryKeys } from "../constants";
import { processInBatches, reverseConvertEquivalents } from "./utils.js";
import { convertClassEquivalents } from "@/services/inferenceCourses";

export const useAddOrUpdateCourseApproval = (throttleLimit = 3) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updatedCourseApprovals) => {
      const preparedCourseEquivalents = reverseConvertEquivalents(updatedCourseApprovals);

      const responses = await processInBatches(
        preparedCourseEquivalents,
        throttleLimit,
        (updatedAndPreparedEquivalent) => courseApprovalService.addOrUpdateCourseApproval(updatedAndPreparedEquivalent)
      );

      const itemsToConvert = responses.map((response) => response.data.items);
      return convertClassEquivalents(itemsToConvert);
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: queryKeys.courseEquivalencies.all });
    },
    onError: (error, variables) => {
      datadogLogs.logger.error("Failed to upload course approval", {
        error: error.message,
        courseApprovalCount: variables.length,
      });
    },
  });
};
